import { formatValue } from "../../utils/helpers";
import { CSSProperties } from "react";
import { DisaggregatedMetric } from "../../services/types";
import { indexMetricIds } from "../../utils/dashboardUtils";
import { useDashboardColor } from "../../context/DashboardColorContext";
import DefaultIcon from '../../assets/svgr/port/default-metric.svg';

interface MetricCardProps {
    metric: DisaggregatedMetric;
    width: string;
    svg?: React.FC<React.SVGProps<SVGSVGElement>>;
};

const MetricCard = ({ metric, svg: SvgIcon }: MetricCardProps) => {
    const color = useDashboardColor();
    const IconComponent = SvgIcon || DefaultIcon;

    // Destructure metric properties
    const { id, name, versions } = metric;
    const { value, unit, percent_calc, year } = versions[0];

    const val = unit === "ratio" ? `${percent_calc?.n}/${percent_calc?.d}` : value;

    // Index metric?
    const isIndexMetric = indexMetricIds.includes(metric.id);

    return (
        <div 
            className="relative overflow-hidden group hover:shadow-lg transition-all border rounded-xl bg-white" 
            style={{ 
                borderLeftWidth: isIndexMetric ? "4px" : undefined, borderLeftColor: isIndexMetric ? color : undefined,
                }}
        >
            <div className="p-4">
                <div className="flex items-start justify-between mb-1">
                    <div className="flex items-center space-x-2">
                        {/* Metric Icon (dynamic colors) */}
                        {SvgIcon && (
                            <div
                                className="group rounded-lg p-2 transition-colors bg-[var(--bg)] group-hover:bg-[var(--bg-hover)]"
                                style={
                                    {
                                    "--bg": `${color}20`,
                                    "--bg-hover": `${color}40`,
                                    } as CSSProperties
                                }
                            >
                                <IconComponent
                                    className="w-6 h-6"
                                    style={{ color }}
                                    aria-label={`${name} icon`}
                                    role="img"
                                />
                            </div>
                        )}
                        {/* Metric Value */}
                        <span className="text-2xl font-semibold">
                            {formatValue(val, unit, id)}
                        </span>
                    </div>
                </div>

                <div className="space-y-0.5">
                    <h3 className="text-sm font-semibold text-port-text">
                        {name}
                    </h3>
                    <p className="text-port-text text-xs w-full">in {year}</p>
                    {isIndexMetric &&
                        <div className="rounded-lg h-4 w-10 px-1.5 text-[10px] text-white text-center" style={{ backgroundColor: color }}>Index</div> 
                    }
                </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#2258e5]/50 to-[#00ac4e]/50 opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>
    );
};


export default MetricCard;
